// components/ui/Select.jsx
// Created: 2026-07-20
// Project: Giving Words to Voices
// Version: 1.0.0
//
// The Select primitive — a native <select>. The app deliberately uses native
// selects rather than a datalist, because Safari on iPad never renders the
// datalist dropdown; that decision stays. This just gives every select the one
// shape, read from the theme, and (like Input) does not suppress the outline,
// so keyboard focus is visible. Pass <option> children as usual.

import React from 'react';
import { RADIUS } from '../../constants/tokens';
import { DANGER } from '../../constants/palette';

const FONT = { sm: '0.75rem', md: '0.84rem', lg: '0.95rem' };

export default function Select({
  size = 'md',
  invalid = false,
  fullWidth = true,
  style = {},
  children,
  ...rest
}) {
  const theme = rest.theme || {};
  delete rest.theme;

  return (
    <select
      style={{
        width: fullWidth ? '100%' : undefined,
        padding: '7px 10px',
        background: theme.inputBg || theme.card,
        color: theme.text,
        border: `1px solid ${invalid ? (theme.danger || DANGER) : theme.border}`,
        borderRadius: RADIUS.md,
        fontSize: FONT[size] || FONT.md,
        fontFamily: 'inherit',
        boxSizing: 'border-box',
        cursor: 'pointer',
        ...style,
      }}
      {...rest}
    >
      {children}
    </select>
  );
}
